// Add tour experience message
export const ADD_TOUR_EXPERIENCE_MESSAGE_REQUEST = 'ADD_TOUR_EXPERIENCE_MESSAGE_REQUEST';
export const ADD_TOUR_EXPERIENCE_MESSAGE_SUCCESS = 'ADD_TOUR_EXPERIENCE_MESSAGE_SUCCESS';
export const ADD_TOUR_EXPERIENCE_MESSAGE_FAILURE = 'ADD_TOUR_EXPERIENCE_MESSAGE_FAILURE';

//get tour
export const GET_TOUR_EXPERIENCE_MESSAGE_REQUEST = 'GET_TOUR_EXPERIENCE_MESSAGE_REQUEST';
export const GET_TOUR_EXPERIENCE_MESSAGE_SUCCESS = 'GET_TOUR_EXPERIENCE_MESSAGE_SUCCESS';
export const GET_TOUR_EXPERIENCE_MESSAGE_FAILURE = 'GET_TOUR_EXPERIENCE_MESSAGE_FAILURE';

//edit tour
export const EDIT_TOUR_EXPERIENCE_MESSAGE_REQUEST = 'EDIT_TOUR_EXPERIENCE_MESSAGE_REQUEST';
export const EDIT_TOUR_EXPERIENCE_MESSAGE_SUCCESS = 'EDIT_TOUR_EXPERIENCE_MESSAGE_SUCCESS';
export const EDIT_TOUR_EXPERIENCE_MESSAGE_FAILURE = 'EDIT_TOUR_EXPERIENCE_MESSAGE_FAILURE';

//delete
export const DELETE_TOUR_EXPERIENCE_MESSAGE_REQUEST = 'DELETE_TOUR_EXPERIENCE_MESSAGE_REQUEST';
export const DELETE_TOUR_EXPERIENCE_MESSAGE_SUCCESS = 'DELETE_TOUR_EXPERIENCE_MESSAGE_SUCCESS';
export const DELETE_TOUR_EXPERIENCE_MESSAGE_FAILURE = 'DELETE_TOUR_EXPERIENCE_MESSAGE_FAILURE';

export const REMOVE_PREVIOS_TOUR_DATA = 'REMOVE_PREVIOS_TOUR_DATA';
